import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { axCrudRightContentStackedTemplateDirective, axCrudRightContentTemplateDirective, CrudBarComponent } from './crud-bar.component';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { ProgressButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { DebounceClickModule } from '../debounce-click/debounce-click.module';



@NgModule({
  declarations: [CrudBarComponent, axCrudRightContentTemplateDirective, axCrudRightContentStackedTemplateDirective],
  imports: [
    CommonModule,
    ButtonModule,
    ProgressButtonModule,
    DebounceClickModule
  ],
  exports: [CrudBarComponent, axCrudRightContentTemplateDirective, axCrudRightContentStackedTemplateDirective]
})
export class CrudBarModule { }
